<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>编号：</label>
                        <el-input v-model="search_Obj.f_code" clearable @keyup.enter.native="doSearch" style="width: 160px"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>名称：</label>
                        <el-input v-model="search_Obj.f_name" clearable @keyup.enter.native="doSearch" style="width: 160px"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>作业设备号：</label>
                        <el-input v-model="search_Obj.f_work_code" clearable @keyup.enter.native="doSearch" style="width: 160px"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>抽检设备号：</label>
                        <el-input v-model="search_Obj.f_extract_code" clearable @keyup.enter.native="doSearch" style="width: 160px"></el-input>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="code" label="设备编号" sortable="custom"></el-table-column>
                        <el-table-column prop="name" label="名称" sortable="custom"></el-table-column>
                        <el-table-column prop="alias" label="简称" sortable="custom"></el-table-column>
                        <el-table-column prop="time_difference" label="时间差(s)" sortable="custom"></el-table-column>
                        <el-table-column prop="location" label="所在位置" sortable="custom"></el-table-column>
                        <el-table-column prop="extract_code" label="关联非接触设备" sortable="custom"></el-table-column>
                        <el-table-column prop="order_index" label="顺序" sortable="custom"></el-table-column>
                        <el-table-column label="操作" width="220" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Edit
                    width="600px"
                    :id="model_id"
                    :title="edit_title"
                    :isshow="editshow"
                    @on-close="closeEditDialog"
                    @on-save-ok="saveOk">
                </Edit>
                <Info
                    width="600px"
                    :id="model_id"
                    title="查看数据采集器"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
                <DeviceUser
                    width="800px"
                    :device_id="model_id"
                    :device_type="device_type"
                    title="关联报警用户"
                    :isshow="dushow"
                    @on-close="closeDeviceUserDialog">
                </DeviceUser>
                <RelationDevice
                    width="800px"
                    :id="model_id"
                    title="关联配件"
                    :isshow="relation_device_show"
                    @on-close="closeRelationDeviceDialog">
                </RelationDevice>
                <Borrow
                    width="600px"
                    :id="model_id"
                    title="设备借调"
                    :isshow="borrow_show"
                    @on-close="closeBorrowDialog">
                </Borrow>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import DeviceUser from "../deviceuser/list"
import RelationDevice from "./relationdevice"
import Borrow from "./borrow.vue"
import listutil from "@/libs/listutil"

export default {
    name: 'deviceCheckList',
    mixins: [listutil],
    components: {Edit, Info, DeviceUser, Btns, LabBtns, RelationDevice, Borrow},
    data() {
        return {
            m_name: '数据采集器',
            menu_id: 3400,
            list_url: "/api/admin/devicecheck/list",
            search_Obj: {
                f_code: '',
                f_name: '',
                f_work_code: '',
                f_extract_code: '',
            },
            del_Obj:{
                url:'/api/admin/devicecheck/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['device_state'],
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
            dushow: false,
            device_type: 2,
            relation_device_show: false,
            borrow_show: false,
        };
    },
    methods: {
        relationUser(index, row){
            this.model_id = row.id
            this.dushow = true
        },
        closeDeviceUserDialog() {
            this.dushow = false
        },
        relationDevice(index, row){
            this.model_id = row.id
            this.relation_device_show = true
        },
        closeRelationDeviceDialog() {
            this.relation_device_show = false
            this.getListData()
        },
        borrow(index, row){
            this.model_id = row.id
            this.borrow_show = true
        },
        closeBorrowDialog(){
            this.borrow_show = false
            this.getListData()
        }
    }
};
</script>